export const FeedbackConstant = {
    title: {en:"Was this answer appropriate?", hi:"क्या यह उत्तर उचित था?", or: "ଏହି ଉତ୍ତରଟି ଠିକ୍ ଥିଲା କି?", mr: "हे उत्तर योग्य होते का?"},
    options: [
        {
            label: {en:"Yes", hi:"हाँ", or: "ହଁ", mr: "होय"},
            value: "like",
            image: "ThumbsUp.svg"
        },
        {
            label: {en:"No", hi:"नहीं", or: "ନା", mr: "नाही"},
            value: "dislike",
            image: "ThumbsDown.svg"
        }
    ]
}

export const FeedbackValues = {
    "LIKE": "like",
    "DISLIKE": "dislike"
}